import React from 'react';

import { Tooltip } from 'opencare-crown';
import { LockSvg } from 'pages/common/components/svgs/LockSvg';

import { SecureText, SecureWrapper } from './SecureBadge-styled-components';

export const SecureBadge = () => (
  <Tooltip
    title="256-bit SSL encrypted, HIPAA and PIPEDA compliant. Free booking on Opencare. No cancellation fees."
    placement="bottom"
    overlayInnerStyle={{
      borderRadius: '8px',
      padding: '8px 16px',
      width: '264px',
    }}
  >
    <SecureWrapper>
      <LockSvg />
      <SecureText>Secure</SecureText>
    </SecureWrapper>
  </Tooltip>
);

